class customAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.accordionTriggers && this.accordionTriggers.length > 0) {
      this.accordionTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleTriggerClick);
      });
    }
  }

  init() {
    this.accordionTriggers = this.querySelectorAll('.js-accordion-trigger');

    if (this.accordionTriggers.length > 0) {
      this.accordionTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleTriggerClick);
        trigger.addEventListener('click', this.handleTriggerClick);
      });
    }
  }

  handleTriggerClick = (e) => {
    this.toggleType(e);
  };

  toggleType(e) {
    let type = this.getAttribute('data-type');
    let triggerBtn = e.target.nodeType === 'BUTTON' ? e.target : e.target.closest('button');

    if (type === 'only-one') {
      var timer = 0;
      this.accordionTriggers.forEach((trigger) => {
        if (trigger !== triggerBtn) {
          if (trigger.getAttribute('aria-expanded') === 'true') {
            timer = 800;
          }
          trigger.setAttribute('aria-expanded', 'false');

          if (trigger.nextElementSibling) {
            trigger.nextElementSibling.setAttribute('aria-hidden', 'true');
          }
          const wrapper = trigger.closest('.aside-cart__recommendations-wrapper');
          
          if (wrapper) {
            wrapper.classList.remove('is-open');
          }
        }
      });

      setTimeout(() => {
        this.toggleAccordion(triggerBtn);
      }, timer);
    } else {
      this.toggleAccordion(triggerBtn);
    }
  }

  toggleAccordion(accordionBtn) {
    if (!accordionBtn) {
      return;
    }

    let isExpanded = accordionBtn.getAttribute('aria-expanded') === 'true';
    accordionBtn.setAttribute('aria-expanded', !isExpanded);

    if (accordionBtn.nextElementSibling) {
      accordionBtn.nextElementSibling.setAttribute('aria-hidden', isExpanded);
    }

    const wrapper = accordionBtn.closest('.aside-cart__recommendations-wrapper');
    
    if (wrapper) {
      wrapper.classList.toggle('is-open', !isExpanded);
    }

    if (!isExpanded) {
      setTimeout(() => {
        const scrollContainer = accordionBtn.closest('.aside-cart__inner');

        if (scrollContainer && wrapper) {
          const targetTop = wrapper.offsetTop - 10;
          
          scrollContainer.scrollTo({ top: targetTop, behavior: 'smooth' });
        }
      }, 250);
    }

    this.dispatchEvent(
      new CustomEvent('accordion:toggle', {
        bubbles: true,
        detail: {
          expanded: !isExpanded,
          trigger: accordionBtn,
        },
      }),
    );
  }
}

if (!customElements.get('custom-accordion')) {
  customElements.define('custom-accordion', customAccordion);
}
